/**
 * Maths
 * Contains generic math-related methods and utilities.
 */

export default class Maths {
  /**
   * @static isNumeric - Determines if a value is numeric or not
   *
   * @param  {any} val the value to parse
   * @returns {boolean}
   */
  static isNumeric(val) {
    return !Number.isNaN(parseFloat(val)) && Number.isFinite(parseFloat(val));
  }

  /**
   * @static Get Formatted Price
   *
   * @param  {number} price
   * @param  {string} locale
   * @param  {string} currency (optional)
   * @returns {mixed} formatted price (e.g. 9.50, $654,321.99, 654 321,99 ₽)
   */
  static getFormattedPrice(price, locale = false, currency = false) {
    if (!locale || !currency) {
      return Number.parseFloat(price).toFixed(2);
    }

    const localeFormatted = locale.replace('_', '-');
    const numberFormatOpt = {
      style: 'currency',
      currency,
    };

    return new Intl.NumberFormat(localeFormatted, numberFormatOpt).format(price);
  }
}
